module.exports = __webpack_public_path__ + "static/media/logo_linkedin.3ffcfcb9.png";